import React, { Component } from 'react';
import axios from 'axios';
import Slider from 'react-slick';
import AnimatedCounter from '../Common/AnimatedCounter';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

class TrainingIndex extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trainings: [],
            trainers: [],
            testimonials: [],
            loadingTrainings: true,
            loadingTrainers: false,
            loadingTestimonials: false,
            error: null,
        };
        this._isMounted = false;
        this.trainingsController = null;
        this.trainersController = null;
        this.testimonialsController = null;
        this.testimonialSliderRef = React.createRef();
    }

    componentDidMount() {
        this._isMounted = true;
        this.fetchTrainings();
        this.fetchTrainers();
        this.fetchTestimonials();
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this.trainingsController) this.trainingsController.abort();
        if (this.trainersController) this.trainersController.abort();
        if (this.testimonialsController) this.testimonialsController.abort();
    }

    fetchTrainings = () => {
        const token = localStorage.getItem('backend-jwt-token');
        this.trainingsController = new AbortController();

        axios.get('/api/trainings/frontend-list', {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            signal: this.trainingsController.signal
        })
        .then(response => {
            if (!this._isMounted) return;
            if (response.data.data) {
                this.setState({
                    trainings: response.data.data,
                    loadingTrainings: false
                });
            }
        })
        .catch(error => {
            if (!this._isMounted) return;
            if (error.name !== 'AbortError' && error.name !== 'CanceledError') {
                console.error('Error fetching trainings:', error);
                this.setState({
                    error: 'Failed to load trainings',
                    loadingTrainings: false
                });
            }
        });
    }

    fetchTrainers = () => {
        const token = localStorage.getItem('backend-jwt-token');

        if (!this._isMounted) return;
        this.setState({ loadingTrainers: true });

        this.trainersController = new AbortController();

        axios.get('/api/trainings/trainers/all', {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            signal: this.trainersController.signal
        })
        .then(response => {
            if (!this._isMounted) return;
            if (response.data.status === 'success' && response.data.data) {
                this.setState({
                    trainers: response.data.data,
                    loadingTrainers: false
                });
            }
        })
        .catch(error => {
            if (!this._isMounted) return;
            if (error.name !== 'AbortError' && error.name !== 'CanceledError') {
                console.error('Error fetching trainers:', error);
                this.setState({
                    loadingTrainers: false
                });
            }
        });
    }

    fetchTestimonials = () => {
        const token = localStorage.getItem('backend-jwt-token');

        if (!this._isMounted) return;
        this.setState({ loadingTestimonials: true });

        this.testimonialsController = new AbortController();

        axios.get('/api/trainings/testimonials/all', {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            signal: this.testimonialsController.signal
        })
        .then(response => {
            if (!this._isMounted) return;
            if (response.data.status === 'success' && response.data.data) {
                this.setState({
                    testimonials: response.data.data,
                    loadingTestimonials: false
                });
            }
        })
        .catch(error => {
            if (!this._isMounted) return;
            if (error.name !== 'AbortError' && error.name !== 'CanceledError') {
                console.error('Error fetching testimonials:', error);
                this.setState({
                    loadingTestimonials: false
                });
            }
        });
    }

    handleViewTraining = (slug) => {
        // Navigate to training detail page using slug
        window.location.href = `/training/${slug}`;
    }

    handleEnrollTraining = (trainingId) => {
        alert('Enrollment functionality coming soon!');
    }

    handleTestimonialPrevClick = () => {
        if (this.testimonialSliderRef.current) {
            this.testimonialSliderRef.current.slickPrev();
        }
    }

    handleTestimonialNextClick = () => {
        if (this.testimonialSliderRef.current) {
            this.testimonialSliderRef.current.slickNext();
        }
    }

    renderStars = (rating) => {
        const stars = [];
        for (let i = 0; i < 5; i++) {
            stars.push(
                <i key={i} className={`fas fa-star ${i < rating ? '' : 'text-muted'}`}></i>
            );
        }
        return stars;
    }

    render() {
        const { trainings, trainers, testimonials, loadingTrainings } = this.state;

        if (loadingTrainings) {
            return (
                <div className="loading-spinner">
                    <p>Loading trainings...</p>
                </div>
            );
        }

    const getBreakpointSettings = (maxSlidesForScreen) => {
      // 1. Cap it at the maximum allowed for this screen size or total jobs
      let computedSlides = Math.min(testimonials.length, maxSlidesForScreen) || 1;

      // 2. Apply your forced-scroll deduction rule
      if (testimonials.length > 1 && testimonials.length <= maxSlidesForScreen) {
        computedSlides = testimonials.length - 1;
      }

      const shouldScroll = testimonials.length > computedSlides;

      return {
        slidesToShow: computedSlides,
        infinite: shouldScroll,
        // autoplay: shouldScroll,
      };
    };

  const desktopSettings = getBreakpointSettings(3);


        const slickSettings = {
            dots: false,
            // infinite: true,
            speed: 500,
            // slidesToShow: 3,

            slidesToShow: desktopSettings.slidesToShow,
            infinite: desktopSettings.infinite,

            slidesToScroll: 3,
            arrows: false,
            adaptiveHeight: false,
            lazyLoad: false,
            touchMove: true,
            swipeToSlide: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                         ...getBreakpointSettings(2),
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        ...getBreakpointSettings(1),
                        slidesToScroll: 1,
                    }
                }
            ]
        };

        return (
            <div className="training-homepage">

                <div className="container">
                    <div className="hero-section">
                        <div className="hero-wrapper">
                            <div className="hero-content">
                                <h1>
                                    Grow Your Skills in Nepal with Solid Future
                                    <span className="hero-highlight"> &mdash; Shape Your Future Today</span>
                                </h1>
                                <p>
                                    Learn practical skills, gain expert guidance, and start your journey toward a successful future with hands-on training, mentorship, and career opportunities designed just for you.
                                </p>
                                <div className="hero-buttons">
                                    <button className="text-white py-2 flex-1 bg-secondary rounded">Browse Courses</button>
                                    <button className="text-white py-2 flex-1 bg-primary rounded">Enroll Now</button>
                                </div>
                            </div>
                            <div className="hero-image">
                                <img src="/uploads/trainings/TrainingHero.png" alt="Training" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Features Section */}
                <section className="features-section">
                    <div className="container">
                        <div className="bg-gray features-content">
                            <h2 className="section-title">Learn, Grow, and Get Placed with Our Module Program</h2>
                            <div className="features-grid">
                                <div className="feature-box">
                                    <div className="feature-icon">
                                        <i className="fas fa-user-tie"></i>
                                    </div>
                                    <h5>Expert Mentorship</h5>
                                    <p>Learn directly from industry professionals.</p>
                                </div>
                                <div className="feature-box">
                                    <div className="feature-icon">
                                        <i className="fas fa-graduation-cap"></i>
                                    </div>
                                    <h5>Practical Skills Training</h5>
                                    <p>Hands-on projects to build real-world experience.</p>
                                </div>
                                <div className="feature-box">
                                    <div className="feature-icon">
                                        <i className="fas fa-share-alt"></i>
                                    </div>
                                    <h5>Career Guidance</h5>
                                    <p>Personalized support to shape your career path.</p>
                                </div>
                                <div className="feature-box">
                                    <div className="feature-icon">
                                        <i className="fas fa-briefcase"></i>
                                    </div>
                                    <h5>100% Placement Assistance</h5>
                                    <p>Get ready for interviews and job opportunities with full placement support.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Unlock Opportunities Section */}
                <section className="unlock-section">
                    <div className="container">
                        <div className="bg-gray unlock-content">
                            <h2>Unlock New Opportunities Through Our Training</h2>
                            <h6>Find the perfect training to advance your career.</h6>
                            <p>
                                Gain hands-on experience in Digital Marketing, Accounting, HR, Excel, QA, and Job-Oriented programs. Our experienced trainers provide step-by-step guidance to help you master practical skills. Enroll today and take the next step toward your professional growth.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Training Cards List */}
                <section className="trainings-section">
                    <div className="container">
                        {trainings.length > 0 ? (
                            <div className="trainings-list">
                                {trainings.map((training, index) => (
                                    <div key={index} className="training-card">
                                        <div className="training-card-image">
                                            {training.banner_image ? (
                                                <img
                                                    src={`/uploads/trainings/${training.banner_image}`}
                                                    alt={training.title}
                                                />
                                            ) : (
                                                <div className="training-card-placeholder">
                                                    <i className="fas fa-image"></i>
                                                </div>
                                            )}
                                        </div>
                                        <div className="training-card-body">
                                            <h3 className="training-card-title">{training.title}</h3>
                                            <b className="training-card-tagline">{training.tagline}</b>
                                            <p className="training-card-overview">
                                                {training.course_overview && training.course_overview.length > 240
                                                    ? `${training.course_overview.substring(0, 240)}...`
                                                    : training.course_overview}
                                            </p>
                                            <ul className="training-card-features">
                                                <li><i className="fas fa-check-circle"></i> Hands-on Practical Learning</li>
                                                <li><i className="fas fa-check-circle"></i> Expert-Led Sessions</li>
                                                <li><i className="fas fa-check-circle"></i> Comprehensive HR Curriculum</li>
                                                <li><i className="fas fa-check-circle"></i> Career-Boosting Opportunities</li>
                                                <li><i className="fas fa-check-circle"></i> Certification Upon Completion</li>
                                            </ul>
                                            <div className="training-card-buttons">
                                                <button
                                                    className="btn btn-enroll"
                                                    onClick={() => this.handleEnrollTraining(training.id)}
                                                >
                                                    Enroll Now
                                                </button>
                                                <button
                                                    className="btn btn-view"
                                                    onClick={() => this.handleViewTraining(training.slug)}
                                                >
                                                    View Detail
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="no-trainings">
                                <p>No trainings available at the moment</p>
                            </div>
                        )}
                    </div>
                </section>

                {/* Learn From Our Trainers Section */}
                {trainers.length > 0 && (
                    <section className="trainers-section">
                        <div className="container">
                            <div className="bg-gray border-radius-0 mb-0">
                                <h2 className="section-title">Learn From Our Experienced Trainers</h2>
                                <div className="trainers-grid">
                                    {trainers.map((trainer, index) => (
                                        <div key={index} className="trainer-card">
                                            <div className="trainer-photo-wrap">
                                                {trainer.photo ? (
                                                    <img
                                                        src={`/uploads/emp_img/${trainer.photo}`}
                                                        alt={trainer.name}
                                                        className="trainer-photo"
                                                    />
                                                ) : (
                                                    <div className="trainer-photo trainer-photo-placeholder">
                                                        <i className="fas fa-user"></i>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="trainer-info">
                                                <div className="trainer-name">{trainer.name}</div>
                                                <div className="trainer-designation">{trainer.designation}</div>
                                                <div className="trainer-bio">{trainer.bio || '0+ years of Experience'}</div>
                                                <div className="trainer-social">
                                                    {trainer.facebook_url && (
                                                        <a href={trainer.facebook_url} target="_blank" rel="noopener noreferrer" title="Facebook">
                                                            <i className="fab fa-facebook"></i>
                                                        </a>
                                                    )}
                                                    {trainer.twitter_url && (
                                                        <a href={trainer.twitter_url} target="_blank" rel="noopener noreferrer" title="Twitter">
                                                            <i className="fab fa-twitter"></i>
                                                        </a>
                                                    )}
                                                    {trainer.linkedin_url && (
                                                        <a href={trainer.linkedin_url} target="_blank" rel="noopener noreferrer" title="LinkedIn">
                                                            <i className="fab fa-linkedin"></i>
                                                        </a>
                                                    )}
                                                    {trainer.instagram_url && (
                                                        <a href={trainer.instagram_url} target="_blank" rel="noopener noreferrer" title="Instagram">
                                                            <i className="fab fa-instagram"></i>
                                                        </a>
                                                    )}
                                                    {trainer.whatsapp_number && (
                                                        <a href={`https://wa.me/${trainer.whatsapp_number}`} target="_blank" rel="noopener noreferrer" title="WhatsApp">
                                                            <i className="fab fa-whatsapp"></i>
                                                        </a>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </section>
                )}

                {/* Why Choose Us Section */}
                <section className="why-choose-section">
                    <div className="container">
                        <div className="bg-gray border-radius-0 mb-0">
                            <h2 className="section-title">Why Choose US ?</h2>
                            <div className="why-choose-grid">
                                <div className="why-choose-item">
                                    <div className="why-choose-icon">
                                        <i className="fas fa-user-tie"></i>
                                    </div>
                                    <h6>Industry Expert Trainers</h6>
                                    <p>Learn from experienced HR professionals and corporate trainers with years of hands-on expertise in recruitment, HR operations, and management.</p>
                                </div>
                                <div className="why-choose-item">
                                    <div className="why-choose-icon">
                                        <i className="fas fa-desktop"></i>
                                    </div>
                                    <h6>Practical &amp; Project-Based Learning</h6>
                                    <p>Over 5000+ trainees have successfully completed our courses and are now working with reputed organizations in Nepal and abroad.</p>
                                </div>
                                <div className="why-choose-item">
                                    <div className="why-choose-icon">
                                        <i className="fas fa-handshake"></i>
                                    </div>
                                    <h6>Personalized Mentorship</h6>
                                    <p>Get one-on-one mentoring to help you clarify your career goals, improve your professional profile, and prepare for real job interviews.</p>
                                </div>
                                <div className="why-choose-item">
                                    <div className="why-choose-icon">
                                        <i className="fas fa-certificate"></i>
                                    </div>
                                    <h6>Recognized Certification</h6>
                                    <p>Receive an industry-recognized certificate from Solid Future HR Consulting Pvt. Ltd upon successful completion of your training.</p>
                                </div>
                                <div className="why-choose-item">
                                    <div className="why-choose-icon">
                                        <i className="fas fa-star"></i>
                                    </div>
                                    <h6>100% Placement Assistance</h6>
                                    <p>We don't just train &mdash; we connect you with leading companies and guide you until you secure the right job.</p>
                                </div>
                                <div className="why-choose-item">
                                    <div className="why-choose-icon">
                                        <i className="fas fa-route"></i>
                                    </div>
                                    <h6>Proven Career Success</h6>
                                    <p>Over 5000+ trainees have successfully completed our courses and are now working with reputed organizations in Nepal and abroad.</p>
                                </div>
                                <div className="why-choose-item">
                                    <div className="why-choose-icon">
                                        <i className="fas fa-book"></i>
                                    </div>
                                    <h6>Flexible Learning Options</h6>
                                    <p>Join classes online or offline, weekdays or weekends &mdash; designed to fit your schedule and pace.</p>
                                </div>
                                <div className="why-choose-item">
                                    <div className="why-choose-icon">
                                        <i className="fas fa-chart-line"></i>
                                    </div>
                                    <h6>Value for Your Investment</h6>
                                    <p>High-quality professional training at reasonable fees with installment and discount options.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Feedback From Our Students Section */}
                {testimonials.length > 0 && (
                    <section className="sf-testimonials-section">
                        <div className="sf-container">
                            <div className="bg-gray border-radius-0 mb-0">
                                <h1 className="sf-testimonials-title">FEEDBACK FROM our Students</h1>
                                <div className="sf-testimonials-carousel-wrapper">
                                    <Slider ref={this.testimonialSliderRef} {...slickSettings}>
                                        {testimonials.map((testimonial) => (
                                            <div key={testimonial.id} className="sf-testimonial-card-wrapper">
                                                <div className="sf-testimonial-card">
                                                    <div className="sf-testimonial-avatar-wrap">
                                                        {testimonial.student_photo ? (
                                                            <img
                                                                src={`/uploads/trainings/testimonials/${testimonial.student_photo}`}
                                                                alt={testimonial.student_name}
                                                                className="sf-testimonial-avatar"
                                                            />
                                                        ) : (
                                                            <div className="sf-testimonial-avatar testimonial-avatar-placeholder">
                                                                <i className="fas fa-user"></i>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <h5 className="sf-testimonial-name">{testimonial.student_name}</h5>
                                                    <p className="sf-testimonial-designation">
                                                        {testimonial.designation}
                                                    </p>
                                                    <p className="sf-testimonial-text">{testimonial.testimonial_text}</p>
                                                    <div className="sf-testimonial-rating">
                                                        {this.renderStars(testimonial.rating || 5)}
                                                    </div>
                                                    {testimonial.training && (
                                                        <div className="sf-testimonial-training">
                                                            Completed: {testimonial.training.title}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </Slider>

                                    <div className="sf-testimonials-controls">
                                        <button
                                            onClick={this.handleTestimonialPrevClick}
                                            className="sf-testimonial-arrow-btn sf-arrow-left"
                                            aria-label="Previous testimonials"
                                            type="button"
                                        >
                                            <i className="fas fa-arrow-left"></i>
                                        </button>
                                        <button
                                            onClick={this.handleTestimonialNextClick}
                                            className="sf-testimonial-arrow-btn sf-arrow-right"
                                            aria-label="Next testimonials"
                                            type="button"
                                        >
                                            <i className="fas fa-arrow-right"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                )}

                {/* Statistics Section */}
                <section className="statistics-section">
                    <div className="container">
                        <h2 className="section-title">Our Impact In Numbers</h2>
                        <div className="stats-grid">
                            <div className="stat-item">
                                <h3>
                                    <AnimatedCounter end={98} suffix="%" />
                                </h3>
                                <p>Job Placement Rate</p>
                            </div>
                            <div className="stat-item">
                                <h3>
                                    <AnimatedCounter end={2500} suffix="+" />
                                </h3>
                                <p>Average Salary Increase</p>
                            </div>
                            <div className="stat-item">
                                <h3>
                                    <AnimatedCounter end={98} suffix="%" />
                                </h3>
                                <p>Student Satisfaction</p>
                            </div>
                            <div className="stat-item">
                                <h3>
                                    <AnimatedCounter end={2} suffix=" Months" />
                                </h3>
                                <p>Average Time To Employment</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default TrainingIndex;